// ============= Imports =============
import { SignalRContextProps } from '@/contexts/SignalRContext';

// ============= Constants =============
// Hub name must match the hub name configured in environment variables
// e.g., VITE_SIGNALR_HUB_PATH_WORKSPACE_MESSAGE_RELAY_HUB=/hubs/WorkflowMessageRelayHub
const HUB_NAME = 'workflowMessageRelayHub';

// ============= Types =============
export interface AddClientToGroupWorkflowSessionProps {
  invokeHub: SignalRContextProps['invokeHub'];
  workspaceId: string;
}

// ============= Main Function =============
/**
 * Adds the client to a workspace group in WorkflowMessageRelayHub
 * @param invokeHub Function to invoke SignalR hub methods
 * @param workflowId The workflow ID to join
 * @returns Promise with API response or error
 */
export const addClientToGroupWorkflowSession = async ({
  invokeHub,
  workspaceId,
}: AddClientToGroupWorkflowSessionProps): Promise<any> => {
  try {
    console.log(
      `🔄 Adding client to group [${workspaceId}] in WorkflowMessageRelayHub...`
    );

    if (!workspaceId) {
      throw new Error('workspaceId is required');
    }

    const result = await invokeHub<any>(
      HUB_NAME,
      'AddClientToUsersAsync',
      workspaceId
    );

    console.log(`✅ Client added to group [${workspaceId}] successfully`);
    return result;
  } catch (error) {
    console.error(
      `🔴 Error adding client to group [${workspaceId}] in WorkflowMessageRelayHub:`,
      error
    );
    throw error;
  }
};
